// extracted by mini-css-extract-plugin
export default {"import_wizard_loading":"ImportWizardLoading_import_wizard_loading__P9TAI","spin":"ImportWizardLoading_spin__jENNG"};